import {SimpleCompany} from './SimpleCompany';
import {SimpleDomain} from '../classifications/SimpleDomain';

export class SimpleCompanyWithDomains extends SimpleCompany {
  subscribedDomains?: Array<SimpleDomain>;
}
